import { SORT_BY } from 'hb-react/frontoffice/apps/CommentsV2/constants';

export const sortByItems = [
  {
    label: __('Recents'),
    value: SORT_BY.RECENT,
  },
  {
    label: __('Votes'),
    value: SORT_BY.VOTES,
  },
];
